import React, { FC } from 'react';
import { iconSize } from '../../../constants/icon.constants';
import Icon from '../../@shared/icon';
import { TCompatibleLoaderShowMoreOrLess } from '../types/contentHubCompatibleLoaders.types';

const CompatibleLoaderShowMoreOrLess: FC<TCompatibleLoaderShowMoreOrLess> = (props) => {
  const { tabs, hiddenTabs, selectedTabItems, showMoreLoaders, showMoreLoaderEvent, t } = props;

  return (
    <>
      {!hiddenTabs
        ? selectedTabItems &&
          selectedTabItems?.length > 4 && (
            <section className={'ch-compatible-loaders__show-more-section'}>
              <button className={'ch-compatible-loaders__show-more'} onClick={(): void => showMoreLoaderEvent(!showMoreLoaders)}>
                <span>{!showMoreLoaders ? t('cnhi-showMore') : t('cnhi-showLess')}</span>
                <Icon iconName={!showMoreLoaders ? 'arrow-chevron-down' : 'arrow-chevron-up'} size={iconSize.dsk} color="primary" />
              </button>
            </section>
          )
        : tabs.map((item) => item?.items).reduce((acc, val) => acc.concat(val), []).length > 4 && (
            <section className={'ch-compatible-loaders__show-more-section'}>
              <button className={'ch-compatible-loaders__show-more'} onClick={(): void => showMoreLoaderEvent(!showMoreLoaders)}>
                <span>{!showMoreLoaders ? t('cnhi-showMore') : t('cnhi-showLess')}</span>
                <Icon iconName={!showMoreLoaders ? 'arrow-chevron-down' : 'arrow-chevron-up'} size={iconSize.dsk} color="primary" />
              </button>
            </section>
          )}
    </>
  );
};

export default CompatibleLoaderShowMoreOrLess;
